import React, { useState, useEffect } from "react";
import styles from "./TransactionForm.module.css";

const emptyForm = {
  title: "",
  amount: "",
  category: "",
  transactionDate: "",
  notes: "",
};

const TransactionForm = ({ initialData, onSubmit, onCancel, submitLabel = "حفظ" }) => {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (initialData) {
      setForm({
        title: initialData.title || "",
        amount: initialData.amount || "",
        category: initialData.category || "",
        transactionDate: initialData.transactionDate?.slice(0, 10) || "",
        notes: initialData.notes || "",
      });
    } else {
      setForm(emptyForm);
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      ...form,
      amount: Number(form.amount),
      transactionDate: form.transactionDate
        ? new Date(form.transactionDate).toISOString()
        : new Date().toISOString(),
    });
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <div className={styles.field}>
        <label>العنوان</label>
        <input name="title" value={form.title} onChange={handleChange} required />
      </div>

      <div className={styles.field}>
        <label>المبلغ</label>
        <input
          type="number"
          name="amount"
          value={form.amount}
          onChange={handleChange}
          required
          min="0"
          step="0.01"
        />
      </div>

      <div className={styles.field}>
        <label>الفئة</label>
        <input name="category" value={form.category} onChange={handleChange} />
      </div>

      <div className={styles.field}>
        <label>التاريخ</label>
        <input
          type="date"
          name="transactionDate"
          value={form.transactionDate}
          onChange={handleChange}
        />
      </div>

      <div className={styles.field}>
        <label>ملاحظات</label>
        <textarea name="notes" value={form.notes} onChange={handleChange} />
      </div>

      <div className={styles.actions}>
        <button type="submit" className={styles.saveBtn}>{submitLabel}</button>
        {onCancel && (
          <button type="button" className={styles.cancelBtn} onClick={onCancel}>
            إلغاء
          </button>
        )}
      </div>
    </form>
  );
};

export default TransactionForm;